export default __webpack_public_path__ + "static/wellness-9675eab8213bc99a382fabf555e41265.png";